import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Primary surface for grouped content — same white / slate border language as the app.
 */
export function SectionCard({
  as: Component = 'section',
  className,
  children,
  padded = true,
  ...rest
}) {
  return (
    <Component
      className={cn(
        'bg-white rounded-xl border border-slate-200/90 shadow-sm transition-shadow duration-200 hover:shadow-md sm:rounded-2xl',
        padded && 'p-3 sm:p-5 lg:p-6',
        className
      )}
      {...rest}
    >
      {children}
    </Component>
  );
}
